import React, { useEffect, useState } from 'react'
import { Grid, Button, Box } from '@mui/material'
import BaseAutoComplete from '../../../components/shared/BaseAutoComplete'
import SmallTextField from '../../../components/textfield/SmallTextfield'
import { Gestores, Bibliotecas, Users } from '../../../services/http'
import { func, string, number, object } from 'prop-types'
const FormGestor = ({ onSubmitEnd = () => {}, submitMethod, data, id }) => {
  const [users, setUsers] = useState([])
  const [libraries, setLibraries] = useState([])
  const [form, setForm] = useState({})

  const getUsers = async () => {
    const { data } = await Users().show({ per_page: -1, ativo: true })
    return data.data
  }

  const getLibraries = async () => {
    const { data } = await Bibliotecas().show({ per_page: -1 })
    return data.data
  }

  const init = async () => {
    const users = await getUsers()
    const bibliotecas = await getLibraries()
    setUsers(users)
    setLibraries(bibliotecas)
  }
  useEffect(() => {
    init()

    // if (submitMethod === 'put') {
    //   setForm({ ...form, user_id: data.user_id, biblioteca_id_ })
    // }
  }, [])

  const postGestor = async event => {
    event.preventDefault()
    await Gestores().store(form, {
      notification: true,
      message: 'Sucesso ao cadastrar gestor'
    })
    onSubmitEnd()
  }

  const putGestor = async event => {
    event.preventDefault()
    await Gestores(id).update(form, {
      notification: true,
      message: 'Sucesso ao editar gestor'
    })
    onSubmitEnd()
  }

  const submitOptions = {
    post: postGestor,
    put: putGestor
  }
  const procurarUser = () => {
    return users.find(element => element.id === data.user_id)
  }

  const procurarGestor = () => {
    return libraries.find(element => element.id === data.biblioteca_id)
  }
  const bntText = {
    put: 'Editar',
    post: 'Cadastrar'
  }

  const bibliotecaDefaultValue =
    submitMethod === 'put' ? procurarGestor() : undefined

  const colaboradorDefaultValue =
    submitMethod === 'put' ? procurarUser() : undefined

  return (
    <form onSubmit={submitOptions[submitMethod]}>
      <Grid container rowSpacing={1}>
        <Grid item xs={12} sm={12}>
          <Grid container spacing={3}>
            <Grid xs={12} sm={12} item>
              <BaseAutoComplete
                list={users}
                disabled={submitMethod === 'put'}
                defaultValue={colaboradorDefaultValue}
                listLabel={'name'}
                inputProps={{ label: 'Leitor' }}
                Input={SmallTextField}
                onChange={({ id }) => setForm({ ...form, user_id: id })}
              />
            </Grid>
            <Grid xs={12} sm={12} item>
              <BaseAutoComplete
                list={libraries}
                defaultValue={bibliotecaDefaultValue}
                listLabel={'apelido'}
                inputProps={{ label: 'Biblioteca' }}
                Input={SmallTextField}
                onChange={({ id }) => setForm({ ...form, biblioteca_id: id })}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12}>
          <Box
            sx={{
              height: '100%',
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'flex-end'
            }}
          >
            <Button
              sx={{ mt: 2 }}
              type="submit"
              variant="contained"
              color="leitura"
            >
              {bntText[submitMethod]}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </form>
  )
}
FormGestor.propTypes = {
  onSubmitEnd: func,
  submitMethod: string,
  id: number,
  data: object
}

export default FormGestor
